/* eslint-disable import/prefer-default-export */

export const DATA_TABLE_EL_CHANGED = 'DATA_TABLE_EL_CHANGED';
export const FILTERS_CHANGED = 'FILTERS_CHANGED';

export const DEFAULT_CSV_COLUMNS = [
  "event", "amount", "ticket_name", "buyer_email",
  "event_id", "event_date", "venue_name", "payout_date",
  "id", "order_id", "created_at", "source_type", "source_id",
  "origin_type", "origin_id", "category", "state", "cash",
  "opendate_distribution", "ticket", "add_on", "other",
  "venue_royalty", "roundup", "opendate_royalty", "processing",
  "taxes", "memo"
];
